<template>
    <div class="faq-container">
        <div class="container">
            <div class="inner-page-title">Cookie Consent Explained</div>
            <div class="terms-body">
                Cookies are integral to the way modern websites work. Most personalisation and social media integration on websites relies on cookies in one way or another. Cookies build up profiles that are very valuable to brands and advertisers for targeted marketing.
                <br/><br/>
                However, using cookies could be seen as an invasion of privacy, and because it is a fairly quiet technology – this can be happening to you without you realising it, or being able to stop it if you wanted to.
                <br/><br/>
                To help you become more aware of this activity, and give you a say in whether you want to allow it to happen, new EU-wide privacy legislation was put in place in 2011. This has become known as the Cookie Law.
                <br/><br/>
                The Cookie Law requires that websites give you clear, detailed information about how they use cookies, and provide ways for you to signal whether or not you want to allow such use. The website is then required by law to respect your wishes. This might mean they block the cookies you don’t like.
                <br/><br/>
                Some websites will allow you to choose which types of cookies to allow or block, although in some cases if you do this you may not be able to use the website at all.
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CookieConsent",
        head: {
            title: 'Cookie consent | Fine Wine Trading App',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
                }
            ],
            bodyAttrs: {
                class: 'page-terms trading-desk'
            }
        }
    }
</script>

<style scoped>
    .faq-container {
        background: #ffffff;
        padding-top: 80px;
    }
    .container {
        max-width: 1170px;
        padding: 0;
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    }
    .inner-page-title {
        font-size: 49px;
        line-height: 49px;
        text-align: center;
        color: #303030;
        margin-top: 47px;
        margin-bottom: 53px;
    }
    .terms-body {
        padding: 100px 0;
        font-size: 16px;
        font-weight: 400;
    }
</style>
<style>
    .barcode-page .logo {
        padding-right: 0;
    }
    .v-navigation-drawer--is-mobile {
        z-index: 106;
    }
</style>
